import { PlayVideos } from "../Analysis/containers";

export default function VideoPlayerTest() {
  return <PlayVideos />;
}
